import React from 'react';
import { Card } from '../../Library/Card';
import { Box, Grid, Typography } from '@mui/material';
import { colors } from '../../../utils/theme';
import { StressInsightsLineChart } from '../../../atoms/charts/StressInsightsLineChart';
import { HormoneSnapshot } from '../../../types';

export const CortisolMetricsGraphCard = ({
  snapshot,
}: {
  snapshot: HormoneSnapshot;
}) => {
  return (
    <Box sx={{ my: 3 }}>
      <Card
        title="Cortisol over 24hrs"
        subtitle="Your daily cortisol levels compared to the optimal range"
        content={
          <Grid container flexDirection="column">
            <Grid item sx={{ my: 2.5 }}>
              <Grid container flexDirection="row" gap={2}>
                <Grid
                  container
                  item
                  flexDirection="row"
                  alignItems="center"
                  sx={{ width: 90 }}
                >
                  <div
                    style={{
                      background: colors.greys.BRAND_BLACK,
                      borderRadius: 50,
                      width: 8,
                      height: 8,
                    }}
                  />
                  <Typography
                    variant="light"
                    fontSize={14}
                    sx={{ ml: 1, color: colors.greys.TEXT_BLACK }}
                  >
                    Your range
                  </Typography>
                </Grid>
                <Grid
                  container
                  item
                  flexDirection="row"
                  alignItems="center"
                  sx={{ width: 120 }}
                >
                  <div
                    style={{
                      background: colors.primarys.GREEN,
                      borderRadius: 50,
                      width: 8,
                      height: 8,
                    }}
                  />
                  <Typography
                    variant="light"
                    fontSize={14}
                    sx={{ ml: 1, color: colors.greys.TEXT_BLACK }}
                  >
                    Optimal range
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            {snapshot && <StressInsightsLineChart snapshot={snapshot} />}
          </Grid>
        }
      />
    </Box>
  );
};
